import {
  Avatar,
  type AvatarSize,
  type AvatarViewingContext,
} from '@procurify/ui'

import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { useUserAvatarViewingContext } from './useUserAvatarViewingContext'

export interface IUserAvatarProps {
  url?: string
  name: string
  userId?: number
  viewingContext?: AvatarViewingContext
  shadow?: boolean
  size?: AvatarSize
  /**
   * Hides the avatar from assistive tech. Use it when visible text beside the
   * avatar already names the user, so the name is not announced twice.
   */
  decorative?: boolean
}

export const UserAvatar = ({
  url,
  name,
  userId,
  viewingContext,
  size,
  shadow,
  decorative,
}: IUserAvatarProps) => {
  const formatMedia = useFormatMedia()

  const photoUrl = url ? formatMedia(url) : undefined

  const resolvedViewingContext = useUserAvatarViewingContext(
    userId,
    viewingContext
  )

  return (
    <Avatar
      photoUrl={photoUrl}
      name={name}
      viewingContext={resolvedViewingContext}
      size={size}
      shadow={shadow}
      decorative={decorative}
    />
  )
}

UserAvatar.displayName = 'UserAvatar'
